import { render, staticRenderFns } from "./ProductAutocomplete.vue?vue&type=template&id=6b1a8854&"
import script from "./ProductAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./ProductAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports